<template>
  <div id="content">
      <div class="inner">
        <h1 v-translate>Přístup odepřen</h1>
      </div>
    <div class="responsiveTabs r-tabs">
      <div class="tabs_content" id="tab-1">
        <section v-translate>
        Pro požadovanou akci nemáte oprávnění.
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccessDenied"
};
</script>



// WEBPACK FOOTER //
// src/components/AccessDenied.vue